// extracted by mini-css-extract-plugin
export var bordered = "SectionHeader-module--bordered--06b9b";
export var centered = "SectionHeader-module--centered--f9020";
export var constrained = "SectionHeader-module--constrained--39fd0";
export var cta = "SectionHeader-module--cta--9749f";
export var header = "SectionHeader-module--header--a19e4";
export var hero = "SectionHeader-module--hero--947d0";
export var inverted = "SectionHeader-module--inverted--04693";
export var label = "SectionHeader-module--label--7a337";
export var labelDecorated = "SectionHeader-module--labelDecorated--a7d34";
export var margin = "SectionHeader-module--margin--34b61";
export var marginExtraLight = "SectionHeader-module--marginExtraLight--8b94b";
export var marginLight = "SectionHeader-module--marginLight--6e54d";
export var marginTop = "SectionHeader-module--marginTop--72cf6";
export var narrow = "SectionHeader-module--narrow--4ffce";
export var post = "SectionHeader-module--post--a5dbd";
export var sizeHuge = "SectionHeader-module--sizeHuge--18fca";
export var sizeLarge = "SectionHeader-module--sizeLarge--bf3c1";
export var subtitle = "SectionHeader-module--subtitle--a6361";
export var subtitleContrasted = "SectionHeader-module--subtitleContrasted--c1000";
export var subtitleHuge = "SectionHeader-module--subtitleHuge--06928";